export default {
  name: {
    asc: 'name_ASC',
    desc: 'name_DESC',
  },
  company: {
    asc: 'company_ASC',
    desc: 'company_DESC',
  },
  productFamily: {
    asc: 'productFamily_ASC',
    desc: 'productFamily_DESC',
  },
  productLine: {
    asc: 'productLine_ASC',
    desc: 'productLine_DESC',
  },
};
